import { WindowService } from '@gen-epix/ui-core/classes/services/WindowService';

export class NonceUtil {
  public static getNonce(): null | string {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    return (WindowService.getInstance().document.querySelector('meta[property="csp-nonce"]') as HTMLMetaElement)?.nonce;
  }
}
